var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountWhiteFilledIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.4 113.4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,109.2c0-22.9,23.1-41.4,51.6-41.4s51.6,18.5,51.6,41.4H5.2ZM56.7,4.3c-10.6,0-19.3,12.6-19.3,28.2s8.6,28.2,19.3,28.2,19.3-12.6,19.3-28.2-8.6-28.2-19.3-28.2Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountWhiteFilledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "account-white-filled-icon.839819ecce6445333e8acb50abd35096.svg";